$(document).ready(function() {
	$('#forgotModal').modal({
		show : false
	});
	$("#formLogin").validate();
	$("#formRegister").validate();
	$("#emailForm").validate();
	
	$(".submitEmail").click(function(){
		var isvalid = $("#formRegister").valid();
		if (!isvalid) {
			return false;
		}
		
		var isEmailValid = emailValidation('registerMail');
		if (!isEmailValid) {
			return false;
		}
		
		if (grecaptcha.getResponse().length == 0) {
			alert(FmtMessage.getMessage('js.check.googlecaptcha.warn'));
			return false;
		}
		
		var agreeChecked = $("#loginagree").prop("checked");
		if (!agreeChecked) {
			alert(FmtMessage.getMessage('js.social.agreement.check.warning'));
			return;
		}else{
			$('#formRegister').submit();
		}
	});
	
	$("#formRegister").letterCase($.cookie('siteLocale')).validate();
	
	//Strong Password
	$('.password-container').pschecker({ onPasswordValidate: validatePassword, onPasswordMatch: matchPassword });
	
	var submitbutton = $('.submit-button');
	var errorBox = $('.error');
	errorBox.css('visibility', 'hidden');
	submitbutton.attr("disabled", "disabled");

    //this function will handle onPasswordValidate callback, which mererly checks the password against minimum length
    function validatePassword(isValid) {
        if (!isValid) {
            errorBox.css('visibility', 'visible');
        } else {
        	errorBox.css('visibility', 'hidden');
    	}
    }
    //this function will be called when both passwords match
    function matchPassword(isMatched) {
        if (isMatched) {
            submitbutton.addClass('unlocked').removeClass('locked');
            submitbutton.removeAttr("disabled", "disabled");
        } else {
            submitbutton.attr("disabled", "disabled");
            submitbutton.addClass('locked').removeClass('unlocked');
        }
    }
});

function showEmailSendDialog() {
	$('#forgotModal').modal('show');
}